// extracted by mini-css-extract-plugin
export default {"awardrm":"awardrm_awardrm__JOlVO","award_item":"awardrm_award_item__dDZEF"};